const EN = {
    title: 'Clients',
    table: {
        title: 'Client list',
        columns: {
            fullname: 'Full name',
            document: 'INE',
            created: 'Created',
            phone: 'Phone number',
            status: 'Status',
            actions: 'Actions'
        },
        status: {
            1: 'Pending',
            2: 'Active',
            3: 'Recover',
            4: 'Blocked',
            5: 'Inactive',
            title: 'Status'
        },
        menu: {
            viewProfile: 'View profile',
            unsubscribe: {
                title: 'Unsubscribe',
                modal: {
                    title: 'Do you wish to unsubscribe',
                    date: 'Date',
                    reason: 'Reason',
                    placeholder: 'Reason...',
                    warningEmpty: 'You must enter a reason to continue',
                    warningExcess: 'The 100 characters limit has been exceed',
                    success: 'The unsubscription request has been created successfully'
                }
            },
        }
    }
};

export default EN;
